import { isSupportedLanguageCode } from '@monorepo/types';
import { useGetEnvironment } from './use-get-environment';

// Extract language from current path
const getCurrentLanguage = (): string => {
  const pathSegments = window.location.pathname.split('/').filter(Boolean);
  const potentialLang = pathSegments[0];
  return isSupportedLanguageCode(potentialLang) ? potentialLang : 'en';
};

export const useGetLogoutUrl = (): string => {
  const { isVite, isNextJs } = useGetEnvironment();

  const language = getCurrentLanguage();
  const logoutPath = `/${language}/logout`;

  let logoutUrl = '';
  if (isVite) {
    logoutUrl = new URL(logoutPath, window.location.origin).toString();
  }

  if (isNextJs) {
    if (!process.env.NEXT_PUBLIC_HUB_URL) {
      throw new Error('NEXT_PUBLIC_HUB_URL is not set in nextjs environment');
    }
    logoutUrl = new URL(logoutPath, process.env.NEXT_PUBLIC_HUB_URL).toString();
  }

  return logoutUrl;
};
